var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail create" }, [
    _c("div", { staticClass: "screen" }, [
      _c(
        "div",
        { staticClass: "banner" },
        [
          _c("mt-field", {
            attrs: { readonly: "", label: "表单编号" },
            model: {
              value: _vm.detail.businessKey,
              callback: function($$v) {
                _vm.$set(_vm.detail, "businessKey", $$v)
              },
              expression: "detail.businessKey"
            }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "center" },
      [
        _c("applicant-info", {
          attrs: {
            editable: false,
            costName: _vm.displayCostCenter,
            lineName: _vm.detail.businessLineName,
            applicant: _vm.detail.applicantName,
            createUserName: _vm.detail.submiterName,
            createDate: _vm.detail.applicationDateStr
          }
        }),
        _vm.detail.currentRole == 100 ||
        _vm.detail.currentRole == 2 ||
        _vm.detail.currentRole == 3 ||
        _vm.detail.currentRole == 10
          ? _c(
              "div",
              { staticClass: "a_infor", class: { open: _vm.isOpen } },
              [
                _c(
                  "p",
                  {
                    on: {
                      click: function($event) {
                        _vm.isOpen = !_vm.isOpen
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.title))]
                ),
                _c(
                  "div",
                  { staticClass: "box" },
                  [
                    _vm.detail.currentRole != "10"
                      ? _c("mt-radio", {
                          attrs: {
                            title: "协议类型：",
                            options: _vm.TypeOptions
                          },
                          model: {
                            value: _vm.request.protocolType,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "protocolType", $$v)
                            },
                            expression: "request.protocolType"
                          }
                        })
                      : _c("mt-field", {
                          attrs: { readonly: "", label: "协议类型：" },
                          model: {
                            value: _vm.detail.protocolTypeStr,
                            callback: function($$v) {
                              _vm.$set(_vm.detail, "protocolTypeStr", $$v)
                            },
                            expression: "detail.protocolTypeStr"
                          }
                        }),
                    _vm.detail.currentRole != "10"
                      ? _c("mt-radio", {
                          attrs: {
                            title: "签订类型：",
                            options: _vm.SignedOptions
                          },
                          model: {
                            value: _vm.request.signType,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "signType", $$v)
                            },
                            expression: "request.signType"
                          }
                        })
                      : _c("mt-field", {
                          attrs: { readonly: "", label: "签订类型：" },
                          model: {
                            value: _vm.detail.signTypeStr,
                            callback: function($$v) {
                              _vm.$set(_vm.detail, "signTypeStr", $$v)
                            },
                            expression: "detail.signTypeStr"
                          }
                        }),
                    _c(
                      "a",
                      { staticClass: "mint-cell mint-field choose" },
                      [
                        _c("div", { staticClass: "mint-cell-wrapper" }, [
                          _vm._m(0),
                          _c(
                            "div",
                            {
                              staticClass: "mint-cell-value",
                              on: { click: _vm.showFiscalYearPup }
                            },
                            [
                              _c("mt-field", {
                                attrs: { readonly: "" },
                                model: {
                                  value: _vm.fiscalYearName,
                                  callback: function($$v) {
                                    _vm.fiscalYearName = $$v
                                  },
                                  expression: "fiscalYearName"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c(
                          "mt-popup",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "popup-transition": "popup-fade",
                              closeOnClickModal: "true",
                              position: "bottom"
                            },
                            model: {
                              value: _vm.popupFiscalYearVisible,
                              callback: function($$v) {
                                _vm.popupFiscalYearVisible = $$v
                              },
                              expression: "popupFiscalYearVisible"
                            }
                          },
                          [
                            _c(
                              "mt-picker",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  slots: _vm.fiscalYearList,
                                  "value-key": "label",
                                  showToolbar: ""
                                },
                                on: { change: _vm.onFiscalYearValuesChange }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "picker-toolbar-title" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mint-datetime-action mint-datetime-cancel",
                                        on: {
                                          click: function($event) {
                                            _vm.popupFiscalYearVisible = !_vm.popupFiscalYearVisible
                                          }
                                        }
                                      },
                                      [_vm._v(" 关闭 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mint-datetime-action mint-datetime-confirm",
                                        on: {
                                          click: _vm.confirmFiscalYearSelect
                                        }
                                      },
                                      [_vm._v(" 确定 ")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("mt-checklist", {
                      attrs: {
                        title: "服务类型",
                        options: _vm.serviceTypeOptions
                      },
                      model: {
                        value: _vm.serviceTypeCheckList,
                        callback: function($$v) {
                          _vm.serviceTypeCheckList = $$v
                        },
                        expression: "serviceTypeCheckList"
                      }
                    }),
                    _vm.serviceTypeCheckOther
                      ? _c("mt-field", {
                          attrs: {
                            label: "其他服务类型",
                            placeholder: "请输入其他服务类型"
                          },
                          model: {
                            value: _vm.serviceTypeOtherDesc,
                            callback: function($$v) {
                              _vm.serviceTypeOtherDesc = $$v
                            },
                            expression: "serviceTypeOtherDesc"
                          }
                        })
                      : _vm._e(),
                    !(
                      _vm.request.protocolType == "20" &&
                      _vm.request.signType == "10"
                    )
                      ? _c(
                          "a",
                          { staticClass: "mint-cell mint-field choose" },
                          [
                            _c("div", { staticClass: "mint-cell-wrapper" }, [
                              _vm._m(1),
                              _c(
                                "div",
                                {
                                  staticClass: "mint-cell-value",
                                  on: { click: _vm.showIncrementPup }
                                },
                                [
                                  _c("mt-field", {
                                    attrs: { readonly: "" },
                                    model: {
                                      value: _vm.incrementName,
                                      callback: function($$v) {
                                        _vm.incrementName = $$v
                                      },
                                      expression: "incrementName"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c(
                              "mt-popup",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "popup-transition": "popup-fade",
                                  closeOnClickModal: "true",
                                  position: "bottom"
                                },
                                model: {
                                  value: _vm.incrementPopupVisible,
                                  callback: function($$v) {
                                    _vm.incrementPopupVisible = $$v
                                  },
                                  expression: "incrementPopupVisible"
                                }
                              },
                              [
                                _c(
                                  "mt-picker",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      slots: _vm.incrementList,
                                      "value-key": "className",
                                      showToolbar: ""
                                    },
                                    on: { change: _vm.onIncrementValuesChange }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "picker-toolbar-title" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mint-datetime-action mint-datetime-cancel",
                                            on: {
                                              click: function($event) {
                                                _vm.incrementPopupVisible = !_vm.incrementPopupVisible
                                              }
                                            }
                                          },
                                          [_vm._v(" 关闭 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mint-datetime-action mint-datetime-confirm",
                                            on: {
                                              click: _vm.confirmIncrementSelect
                                            }
                                          },
                                          [_vm._v(" 确定 ")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    !(
                      _vm.request.protocolType == "20" &&
                      _vm.request.signType == "10"
                    )
                      ? _c(
                          "a",
                          { staticClass: "mint-cell mint-field choose" },
                          [
                            _c("div", { staticClass: "mint-cell-wrapper" }, [
                              _vm._m(2),
                              _c(
                                "div",
                                {
                                  staticClass: "mint-cell-value",
                                  on: { click: _vm.showDecrementPup }
                                },
                                [
                                  _c("mt-field", {
                                    attrs: { readonly: "" },
                                    model: {
                                      value: _vm.decrementName,
                                      callback: function($$v) {
                                        _vm.decrementName = $$v
                                      },
                                      expression: "decrementName"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c(
                              "mt-popup",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "popup-transition": "popup-fade",
                                  closeOnClickModal: "true",
                                  position: "bottom"
                                },
                                model: {
                                  value: _vm.decrementVisible,
                                  callback: function($$v) {
                                    _vm.decrementVisible = $$v
                                  },
                                  expression: "decrementVisible"
                                }
                              },
                              [
                                _c(
                                  "mt-picker",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      slots: _vm.decrementList,
                                      "value-key": "className",
                                      showToolbar: ""
                                    },
                                    on: { change: _vm.onDecrementValuesChange }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "picker-toolbar-title" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mint-datetime-action mint-datetime-cancel",
                                            on: {
                                              click: function($event) {
                                                _vm.decrementVisible = !_vm.decrementVisible
                                              }
                                            }
                                          },
                                          [_vm._v(" 关闭 ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mint-datetime-action mint-datetime-confirm",
                                            on: {
                                              click: _vm.DecrementconfirmSelect
                                            }
                                          },
                                          [_vm._v(" 确定 ")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "a",
                      { staticClass: "mint-cell mint-field choose" },
                      [
                        _c("div", { staticClass: "mint-cell-wrapper" }, [
                          _vm._m(3),
                          _c(
                            "div",
                            {
                              staticClass: "mint-cell-value",
                              on: { click: _vm.showSealTypePup }
                            },
                            [
                              _c("mt-field", {
                                attrs: { readonly: "" },
                                model: {
                                  value: _vm.sealTypeName,
                                  callback: function($$v) {
                                    _vm.sealTypeName = $$v
                                  },
                                  expression: "sealTypeName"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c(
                          "mt-popup",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "popup-transition": "popup-fade",
                              closeOnClickModal: "true",
                              position: "bottom"
                            },
                            model: {
                              value: _vm.popupSealTypeVisible,
                              callback: function($$v) {
                                _vm.popupSealTypeVisible = $$v
                              },
                              expression: "popupSealTypeVisible"
                            }
                          },
                          [
                            _c(
                              "mt-picker",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  slots: _vm.sealTypeList,
                                  "value-key": "label",
                                  showToolbar: ""
                                },
                                on: { change: _vm.onSealTypeValuesChange }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "picker-toolbar-title" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mint-datetime-action mint-datetime-cancel",
                                        on: {
                                          click: function($event) {
                                            _vm.popupSealTypeVisible = !_vm.popupSealTypeVisible
                                          }
                                        }
                                      },
                                      [_vm._v(" 关闭 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mint-datetime-action mint-datetime-confirm",
                                        on: { click: _vm.confirmSealTypeSelect }
                                      },
                                      [_vm._v(" 确定 ")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "a",
                      { staticClass: "mint-cell mint-field choose" },
                      [
                        _c("div", { staticClass: "mint-cell-wrapper" }, [
                          _vm._m(4),
                          _c(
                            "div",
                            {
                              staticClass: "mint-cell-value",
                              on: { click: _vm.showSealIndexPup }
                            },
                            [
                              _c("mt-field", {
                                attrs: { readonly: "" },
                                model: {
                                  value: _vm.sealIndexName,
                                  callback: function($$v) {
                                    _vm.sealIndexName = $$v
                                  },
                                  expression: "sealIndexName"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _c(
                          "mt-popup",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "popup-transition": "popup-fade",
                              closeOnClickModal: "true",
                              position: "bottom"
                            },
                            model: {
                              value: _vm.popupSealIndexVisible,
                              callback: function($$v) {
                                _vm.popupSealIndexVisible = $$v
                              },
                              expression: "popupSealIndexVisible"
                            }
                          },
                          [
                            _c(
                              "mt-picker",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  slots: _vm.sealIndexList,
                                  "value-key": "label",
                                  showToolbar: ""
                                },
                                on: { change: _vm.onSealIndexValuesChange }
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "picker-toolbar-title" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mint-datetime-action mint-datetime-cancel",
                                        on: {
                                          click: function($event) {
                                            _vm.popupSealIndexVisible = !_vm.popupSealIndexVisible
                                          }
                                        }
                                      },
                                      [_vm._v(" 关闭 ")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mint-datetime-action mint-datetime-confirm",
                                        on: {
                                          click: _vm.confirmSealIndexSelect
                                        }
                                      },
                                      [_vm._v(" 确定 ")]
                                    )
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("mt-field", {
                      attrs: {
                        label: "合同份数",
                        placeholder: "如：2",
                        onkeypress:
                          "return(/[\\d]/.test(String.fromCharCode(event.keyCode)))"
                      },
                      model: {
                        value: _vm.request.contractCopies,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "contractCopies", $$v)
                        },
                        expression: "request.contractCopies"
                      }
                    }),
                    _vm.startDateType == "1"
                      ? _c("mt-field", {
                          attrs: {
                            readonly: "",
                            label: "合同开始日期",
                            placeholder: "请选择开始日期"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.ShowPicker(1)
                            }
                          },
                          model: {
                            value: _vm.request.startDate,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "startDate", $$v)
                            },
                            expression: "request.startDate"
                          }
                        })
                      : _vm._e(),
                    _vm.startDateType == "0"
                      ? _c("mt-field", {
                          attrs: {
                            label: "合同开始日期",
                            placeholder: "请输入开始日期"
                          },
                          model: {
                            value: _vm.request.startDateDesc,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "startDateDesc", $$v)
                            },
                            expression: "request.startDateDesc"
                          }
                        })
                      : _vm._e(),
                    _vm.request.signType == "10"
                      ? _c("mt-radio", {
                          attrs: {
                            title: "选择日期/手动输入",
                            options: _vm.StartDateOptions
                          },
                          model: {
                            value: _vm.startDateType,
                            callback: function($$v) {
                              _vm.startDateType = $$v
                            },
                            expression: "startDateType"
                          }
                        })
                      : _vm._e(),
                    _vm.endDateType == "1"
                      ? _c("mt-field", {
                          attrs: {
                            readonly: "",
                            label: "合同结束日期",
                            placeholder: "请选择结束日期"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.ShowPicker(2)
                            }
                          },
                          model: {
                            value: _vm.request.endDate,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "endDate", $$v)
                            },
                            expression: "request.endDate"
                          }
                        })
                      : _vm._e(),
                    _vm.endDateType == "0"
                      ? _c("mt-field", {
                          attrs: {
                            label: "合同结束日期",
                            placeholder: "请输入结束日期"
                          },
                          model: {
                            value: _vm.request.endDateDesc,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "endDateDesc", $$v)
                            },
                            expression: "request.endDateDesc"
                          }
                        })
                      : _vm._e(),
                    _vm.request.signType == "10"
                      ? _c("mt-radio", {
                          attrs: {
                            title: "选择日期/手动输入",
                            options: _vm.EndDateOptions
                          },
                          model: {
                            value: _vm.endDateType,
                            callback: function($$v) {
                              _vm.endDateType = $$v
                            },
                            expression: "endDateType"
                          }
                        })
                      : _vm._e(),
                    _c("mt-field", {
                      attrs: {
                        readonly: "",
                        label: "合同期（月）",
                        placeholder: "自动计算"
                      },
                      model: {
                        value: _vm.contractPeriod,
                        callback: function($$v) {
                          _vm.contractPeriod = $$v
                        },
                        expression: "contractPeriod"
                      }
                    }),
                    _c("p", [_vm._v("合同信息（项目简称+签署合同原因）")]),
                    _c("mt-field", {
                      attrs: {
                        placeholder: "如：南京金桐石油化工FS-劳务外包",
                        attr: { maxlength: 50 },
                        type: "textarea",
                        rows: "1"
                      },
                      model: {
                        value: _vm.request.info,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "info", $$v)
                        },
                        expression: "request.info"
                      }
                    }),
                    _c("p", [_vm._v("合同内容")]),
                    _c("mt-field", {
                      attrs: {
                        placeholder:
                          "描述合同的内容及签订的原因或变化的原因，最多300个字",
                        attr: { maxlength: 300 },
                        type: "textarea",
                        rows: "3"
                      },
                      model: {
                        value: _vm.request.contractContent,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "contractContent", $$v)
                        },
                        expression: "request.contractContent"
                      }
                    }),
                    _vm.request.signType != "10"
                      ? _c(
                          "div",
                          { staticClass: "CurrentAmountWithTax_Create" },
                          [
                            _c("mt-radio", {
                              attrs: {
                                title: "原合同金额类型：",
                                options: _vm.amountType
                              },
                              model: {
                                value: _vm.request.curContractType,
                                callback: function($$v) {
                                  _vm.$set(_vm.request, "curContractType", $$v)
                                },
                                expression: "request.curContractType"
                              }
                            }),
                            _vm.request.curContractType == 10
                              ? _c(
                                  "mt-field",
                                  {
                                    attrs: {
                                      label: "原合同金额(含税) ￥",
                                      placeholder: "请输入原合同金额",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.request.currentAmount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.request,
                                          "currentAmount",
                                          $$v
                                        )
                                      },
                                      expression: "request.currentAmount"
                                    }
                                  },
                                  [_vm._v("元")]
                                )
                              : _vm._e(),
                            _vm.request.curContractType == 20
                              ? _c("mt-field", {
                                  attrs: {
                                    label: "原合同金额(含税) ￥",
                                    placeholder: "请输入原合同金额"
                                  },
                                  model: {
                                    value: _vm.request.currentAmount,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.request,
                                        "currentAmount",
                                        $$v
                                      )
                                    },
                                    expression: "request.currentAmount"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.request.signType != "10"
                      ? _c("mt-radio", {
                          attrs: {
                            title: "原合同金额年/月化",
                            options: _vm.curContractAmountRateOptions
                          },
                          model: {
                            value: _vm.request.curContractAmountRate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.request,
                                "curContractAmountRate",
                                $$v
                              )
                            },
                            expression: "request.curContractAmountRate"
                          }
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "CurrentAmountWithTax_Create" },
                      [
                        _c("mt-radio", {
                          attrs: {
                            title: "新合同金额类型：",
                            options: _vm.amountType
                          },
                          model: {
                            value: _vm.request.newContractType,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "newContractType", $$v)
                            },
                            expression: "request.newContractType"
                          }
                        }),
                        _vm.request.newContractType == 10
                          ? _c(
                              "mt-field",
                              {
                                attrs: {
                                  label: "新合同金额(含税) ￥",
                                  placeholder: "请输入新合同金额",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.request.newAmount,
                                  callback: function($$v) {
                                    _vm.$set(_vm.request, "newAmount", $$v)
                                  },
                                  expression: "request.newAmount"
                                }
                              },
                              [_vm._v("元")]
                            )
                          : _vm._e(),
                        _vm.request.newContractType == 20
                          ? _c("mt-field", {
                              attrs: {
                                label: "新合同金额(含税) ￥",
                                placeholder: "请输入新合同金额"
                              },
                              model: {
                                value: _vm.request.newAmount,
                                callback: function($$v) {
                                  _vm.$set(_vm.request, "newAmount", $$v)
                                },
                                expression: "request.newAmount"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c("mt-radio", {
                      attrs: {
                        title: "新合同金额年/月化",
                        options: _vm.newContractAmountRateOptions
                      },
                      model: {
                        value: _vm.request.newContractAmountRate,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "newContractAmountRate", $$v)
                        },
                        expression: "request.newContractAmountRate"
                      }
                    }),
                    _vm.request.newContractAmountRate == 2
                      ? _c(
                          "div",
                          { staticClass: "NewAmountWithTax_Create" },
                          [
                            _c(
                              "mt-field",
                              {
                                attrs: {
                                  label: "新合同年化金额(含税) ￥",
                                  placeholder: "请输入新合同年化金额",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.request.newContractYearAmount,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.request,
                                      "newContractYearAmount",
                                      $$v
                                    )
                                  },
                                  expression: "request.newContractYearAmount"
                                }
                              },
                              [_vm._v("元")]
                            ),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v("(不足一年按合同期填写。)")
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.request.signType != "10"
                      ? _c("mt-field", {
                          attrs: {
                            label: "原利润率",
                            placeholder: "请输入原利润率"
                          },
                          model: {
                            value: _vm.request.currentProfitMargin,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "currentProfitMargin", $$v)
                            },
                            expression: "request.currentProfitMargin"
                          }
                        })
                      : _vm._e(),
                    _c("mt-field", {
                      attrs: {
                        label: "新利润率",
                        placeholder: "请输入新利润率"
                      },
                      model: {
                        value: _vm.request.newProfitMargin,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "newProfitMargin", $$v)
                        },
                        expression: "request.newProfitMargin"
                      }
                    }),
                    _vm.request.signType != "10"
                      ? _c("mt-radio", {
                          attrs: {
                            title: "原付款周期",
                            options: _vm.PaymentOptions
                          },
                          model: {
                            value: _vm.request.currentPaymentTerms,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "currentPaymentTerms", $$v)
                            },
                            expression: "request.currentPaymentTerms"
                          }
                        })
                      : _vm._e(),
                    _vm.request.signType != "10" &&
                    _vm.request.currentPaymentTerms == "30"
                      ? _c("mt-field", {
                          attrs: {
                            placeholder: "请输入原付款周期",
                            attr: { maxlength: 20 }
                          },
                          model: {
                            value: _vm.request.currentPaymentTermsOther,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.request,
                                "currentPaymentTermsOther",
                                $$v
                              )
                            },
                            expression: "request.currentPaymentTermsOther"
                          }
                        })
                      : _vm._e(),
                    _c("mt-radio", {
                      attrs: {
                        title: "新付款周期",
                        options: _vm.PaymentOptions
                      },
                      model: {
                        value: _vm.request.newPaymentTerms,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "newPaymentTerms", $$v)
                        },
                        expression: "request.newPaymentTerms"
                      }
                    }),
                    _vm.request.newPaymentTerms == "30"
                      ? _c("mt-field", {
                          attrs: {
                            placeholder: "请输入新付款周期",
                            attr: { maxlength: 20 }
                          },
                          model: {
                            value: _vm.request.newPaymentTermsOther,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "newPaymentTermsOther", $$v)
                            },
                            expression: "request.newPaymentTermsOther"
                          }
                        })
                      : _vm._e(),
                    _vm.request.signType == "10"
                      ? _c("mt-radio", {
                          staticStyle: { "justify-content": "center" },
                          attrs: {
                            title: "是否添加到SCM系统(仅限新合同填写)",
                            options: _vm.AddSCMOptions
                          },
                          model: {
                            value: _vm.request.addSCMStr,
                            callback: function($$v) {
                              _vm.$set(_vm.request, "addSCMStr", $$v)
                            },
                            expression: "request.addSCMStr"
                          }
                        })
                      : _vm._e(),
                    _vm.currentApproverStr
                      ? _c("mt-field", {
                          attrs: { readonly: "", label: "当前处理人" },
                          model: {
                            value: _vm.currentApproverStr,
                            callback: function($$v) {
                              _vm.currentApproverStr = $$v
                            },
                            expression: "currentApproverStr"
                          }
                        })
                      : _vm._e(),
                    _c("p", [_vm._v("备注")]),
                    _c("mt-field", {
                      staticStyle: { "padding-bottom": "20px" },
                      attrs: {
                        placeholder: "请输入备注信息",
                        attr: { maxlength: 300 },
                        type: "textarea",
                        rows: "3"
                      },
                      model: {
                        value: _vm.request.remark,
                        callback: function($$v) {
                          _vm.$set(_vm.request, "remark", $$v)
                        },
                        expression: "request.remark"
                      }
                    })
                  ],
                  1
                ),
                _c("mt-datetime-picker", {
                  ref: "picker1",
                  attrs: {
                    type: "date",
                    startDate: new Date("2010-01-01"),
                    endDate: new Date("2077-12-31"),
                    "year-format": "{value}年",
                    "month-format": "{value}月",
                    "date-format": "{value}日"
                  },
                  on: { confirm: _vm.handleConfirm1 },
                  nativeOn: {
                    touchmove: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                    }
                  },
                  model: {
                    value: _vm.defaultStartDate,
                    callback: function($$v) {
                      _vm.defaultStartDate = $$v
                    },
                    expression: "defaultStartDate"
                  }
                }),
                _c("mt-datetime-picker", {
                  ref: "picker2",
                  attrs: {
                    type: "date",
                    startDate: _vm.defaultStartDate,
                    endDate: new Date("2077-12-31"),
                    "year-format": "{value}年",
                    "month-format": "{value}月",
                    "date-format": "{value}日"
                  },
                  on: { confirm: _vm.handleConfirm2 },
                  nativeOn: {
                    touchmove: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                    }
                  },
                  model: {
                    value: _vm.defaultEndDate,
                    callback: function($$v) {
                      _vm.defaultEndDate = $$v
                    },
                    expression: "defaultEndDate"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c("attach-upload", {
          attrs: {
            canUpload: true,
            deletable: true,
            maxLength: 100,
            value: _vm.request.attachmentList,
            contractList: _vm.detail.contractList,
            attachFileList: _vm.detail.attachFileList,
            legalList: _vm.detail.legalList,
            coeList: _vm.detail.coeList,
            contractType: 7,
            signType: _vm.request.signType
          }
        }),
        _c(
          "div",
          { staticClass: "a_infor", class: { open: _vm.approveOpen } },
          [
            _c(
              "p",
              {
                staticClass: "red",
                on: {
                  click: function($event) {
                    _vm.approveOpen = !_vm.approveOpen
                  }
                }
              },
              [_vm._v("备注")]
            ),
            _c(
              "div",
              {
                staticClass: "box",
                staticStyle: { "padding-bottom": "20px", "margin-top": "10px" }
              },
              [
                _c("mt-field", {
                  attrs: {
                    placeholder: "请输入...",
                    attr: { maxlength: 200 },
                    type: "textarea",
                    rows: "3"
                  },
                  model: {
                    value: _vm.approveRequest.approveRemark,
                    callback: function($$v) {
                      _vm.$set(_vm.approveRequest, "approveRemark", $$v)
                    },
                    expression: "approveRequest.approveRemark"
                  }
                }),
                _c("ul", { staticClass: "buttons" }, [
                  _c(
                    "li",
                    [
                      _c(
                        "mt-button",
                        {
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              return _vm.ConfirmEdit()
                            }
                          }
                        },
                        [_vm._v("更新")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "li",
                    [
                      _c(
                        "mt-button",
                        {
                          attrs: { type: "default" },
                          on: {
                            click: function($event) {
                              return _vm.GoBack()
                            }
                          }
                        },
                        [_vm._v("返回")]
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "clear" })
              ],
              1
            )
          ]
        ),
        _c("operation-log", {
          attrs: { list: _vm.detail.contractOperationLog }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mint-cell-title" }, [
      _c("span", { staticClass: "mint-cell-text" }, [_vm._v("年度")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mint-cell-title" }, [
      _c("span", { staticClass: "mint-cell-text" }, [_vm._v("增长类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mint-cell-title" }, [
      _c("span", { staticClass: "mint-cell-text" }, [_vm._v("减少类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mint-cell-title" }, [
      _c("span", { staticClass: "mint-cell-text" }, [_vm._v("用章申请")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mint-cell-title" }, [
      _c("span", { staticClass: "mint-cell-text" }, [_vm._v("盖章顺序")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }